import React, { useState, useEffect } from 'react';
import { SafeAreaView, View, FlatList } from 'react-native';
import { Text, Button, Card, Input, Icon } from 'react-native-elements';
import { ScrollView } from 'react-native-gesture-handler';
import { connect } from 'react-redux';
import { RootState } from '../../redux';
import { User } from '../../utils/types/Users';
import Firebase from '../../components/FirebaseContext';
import { SuccessToast, FailureToast } from '../../utils';
import firebase from 'firebase';
import { Hospital, fstHelper } from '../../utils/types/others';
import { colors } from '../../utils/constants';
import { Menu, MenuTrigger, MenuOptions, MenuOption, renderers } from 'react-native-popup-menu';

interface HospitalManagerProp {
	user: User;
}

function HospitalManager({ user }: HospitalManagerProp): JSX.Element {
	const firestore = Firebase.firestore();
	const [name, setName] = useState('');
	const [address, setAddress] = useState<string>();
	const [contactName, setContactName] = useState<string>();
	const [contactEmail, setContactEmail] = useState<string>();
	const [contactPhone, setContactPhone] = useState<string>();
	const [loading, setLoading] = useState(false);
	const [savedHospitals, setSavedHospitals] = useState<Array<{ docId: string; hospital: Hospital }>>([]);

	const [editId, setEditId] = useState<string>();
	useEffect(() => {
		//load all existing projects order by date created desc

		if (editId == undefined || editId == 'refresh') {
			firestore
				.collection('hospitals')
				.orderBy('createdAt', 'desc')
				.get()
				.then((res) => {
					if (!res.empty) {
						const hospitals = res.docs.map((h) => {
							return { docId: h.id, hospital: h.data() as Hospital };
						});
						setSavedHospitals(hospitals);
					}
				});
			setEditId(undefined);
		}
	}, [firestore, editId]);

	const resetHospitalForm = () => {
		setName('');
		setAddress('');
		setContactName('');
		setContactEmail('');
		setContactPhone('');
	};

	return (
		<SafeAreaView style={{ flex: 1, flexDirection: 'row' }}>
			<View style={{ flex: 1 }}>
				<Text style={{ fontWeight: '700', marginBottom: 20, textAlign: 'center', marginTop: 20 }} h4>
					Hospital Database
				</Text>
				<FlatList
					data={savedHospitals}
					renderItem={({ item }) => {
						const { docId, hospital } = item;
						return (
							<Card>
								<Text h4>
									{hospital.name} | {hospital.id}
								</Text>
								{hospital.address ? <Text>Address: {hospital.address}</Text> : <></>}
								{hospital.address ? <Text>Contact Person: : {hospital.contactName}</Text> : <></>}
								<Text>
									{hospital.contactEmail ? `Email: ' ${hospital.contactEmail} | ` : ''}
									{hospital.contactPhone ? `Phone: ' ${hospital.contactPhone} | ` : ''}
								</Text>
								<Text>Added on {(((hospital.createdAt as fstHelper).toDate() as unknown) as Date).toDateString()}</Text>
								<View style={{ flexDirection: 'row', position: 'absolute', right: 0 }}>
									<Icon
										reverse
										name="edit-3"
										type="feather"
										size={16}
										color={colors.green}
										onPress={() => {
											setName(hospital.name);
											setAddress(hospital.address);
											setContactName(hospital.contactName);
											setContactEmail(hospital.contactEmail);
											setContactPhone(hospital.contactPhone);
											setEditId(docId);
										}}
									/>
									<Menu renderer={renderers.Popover} rendererProps={{ preferredPlacement: 'bottom' }}>
										<MenuTrigger>
											<Icon reverse name="trash-2" type="feather" size={16} color={colors.red} />
										</MenuTrigger>
										<MenuOptions customStyles={{ optionsWrapper: { padding: 10 } }}>
											<Text style={{ color: colors.darkRed, fontWeight: '700' }}>This action is irreversible!</Text>
											<View style={{ flexDirection: 'row', justifyContent: 'space-around', marginVertical: 16 }}>
												<MenuOption
													text="Cancel"
													customStyles={{
														optionWrapper: { backgroundColor: colors.blue, borderRadius: 4, paddingHorizontal: 6 },
														optionText: { color: '#fff' },
													}}
												/>
												<MenuOption
													text="Yes delete"
													customStyles={{
														optionWrapper: { backgroundColor: colors.red, borderRadius: 4, paddingHorizontal: 6 },
														optionText: { color: '#fff' },
													}}
													onSelect={async () => {
														await firestore.collection('hospitals').doc(docId).delete();
														setEditId('refresh');
														SuccessToast(`HIA ${hospital.id} has been deleted!`);
													}}
												/>
											</View>
										</MenuOptions>
									</Menu>
								</View>
							</Card>
						);
					}}
					keyExtractor={(item) => item.hospital.id}
					ListFooterComponent={<View style={{ height: 60 }}></View>}
				/>
			</View>
			<ScrollView style={{ flex: 0.4, backgroundColor: '#45a6dd' }}>
				<Card containerStyle={{ marginBottom: 20 }} title={editId != undefined ? 'Edit Hospital' : 'Add Hospital'}>
					<Input
						placeholder="Enter Hospital name (Required)"
						value={name}
						onChangeText={(text) => {
							setName(text);
						}}
					/>
					<Input
						placeholder="Enter Hospital address"
						value={address}
						onChangeText={(text) => {
							setAddress(text);
						}}
					/>
					<Input
						placeholder="Enter contact person name"
						value={contactName}
						onChangeText={(text) => {
							setContactName(text);
						}}
					/>
					<Input
						placeholder="Enter contact person email"
						value={contactEmail}
						onChangeText={(text) => {
							setContactEmail(text);
						}}
					/>
					<Input
						placeholder="Enter contact person phone"
						value={contactPhone}
						onChangeText={(text) => {
							setContactPhone(text);
						}}
					/>
					<Button
						title={editId == undefined ? 'Save Hospital' : 'Update Hospital'}
						buttonStyle={{ backgroundColor: '#275036', paddingVertical: 6 }}
						containerStyle={{ marginTop: 20 }}
						onPress={async () => {
							if (name.length < 1) {
								FailureToast('Hospital must have a name');
								return;
							}
							// if (address.length < 1) {
							// 	FailureToast('HIA must have an address');
							// 	return;
							// }
							setLoading(true);
							const hospital: Hospital = {
								id: editId ? savedHospitals.find((h) => h.docId == editId)?.hospital.id || '' : `LASHMA-H${Date.now()}`,
								name: name,
								createdAt: editId
									? (savedHospitals.find((h) => h.docId == editId)?.hospital.createdAt as fstHelper).toDate()
									: firebase.firestore.FieldValue.serverTimestamp(),
								createdBy: editId ? savedHospitals.find((h) => h.docId == editId)?.hospital.createdBy || '' : user.uid,
							};
							if (address) hospital.address = address;
							if (contactName) hospital.contactName = contactName;
							if (contactPhone) hospital.contactPhone = contactPhone;
							if (contactEmail) hospital.contactEmail = contactEmail;

							if (editId == undefined) {
								try {
									await firestore.collection('hospitals').add(hospital);
									SuccessToast('Hospital saved!');
									setLoading(false);
									setEditId('refresh');
								} catch (error) {
									console.log(error);
									FailureToast('Failed to save hospital');
									setLoading(false);
								}
							} else {
								try {
									const doc = firestore.collection('hospitals').doc(editId);
									doc.set(hospital);
									SuccessToast('Hospital updated!');
									setLoading(false);
									setEditId(undefined);
								} catch (error) {
									FailureToast('Failed to update hospital');
									setLoading(false);
								}
							}
							resetHospitalForm();
						}}
						loading={loading}
					/>
				</Card>
			</ScrollView>
		</SafeAreaView>
	);
}

const mapStateToProps = (state: RootState) => {
	const { user } = state;
	return {
		user,
	};
};

export default connect(mapStateToProps)(HospitalManager);
